import { SortModelItem } from '@ag-grid-community/core';

/** AG Grid keeps sort on each column. This builds the sortModel array initialState expects. */
export function sortModelFromColumnState(
    columnState: { colId?: string; sort?: string | null; sortIndex?: number | null }[],
): SortModelItem[] {
    return columnState
        .filter((col) => col.sort === 'asc' || col.sort === 'desc')
        .sort((a, b) => (a.sortIndex ?? 0) - (b.sortIndex ?? 0))
        .map((col) => ({ colId: col.colId ?? '', sort: col.sort as 'asc' | 'desc' }))
        .filter((item) => item.colId !== '');
}
